import { Bounce, toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

type ItemProps = {
  toastText: string
}

const Toast = ({ toastText }: ItemProps) => {
  toast.info(toastText, {
    position: 'bottom-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
    transition: Bounce
  })

  return <ToastContainer />
}

export { Toast }
